import React from 'react';
import FleetList from './FleetList';

const FleetManagement = () => {
  return <FleetList />;
};

export default FleetManagement;
